<div class="list-container">
  @for (item of list(); track item) {
    <div class="item-container">
      <div 
        class="item" 
        [class.selected]="item.selected"
        (click)="selectItem(item)">
          {{item.label | translate}}
      </div>
      @if(item.provider === 'custom'){
        <div (click)="delete(item)">
          <mat-icon>delete_outline</mat-icon>
        </div> 
      }
    </div>
  }
  @if(!addingNew){
    <div class="add-new" (click)="addNew()">
      <mat-icon>add_circle_outlined</mat-icon>
      <span>{{'labels.add_new' | translate}}</span>
    </div>
  }@else{
    <div class="add-new-container">
      <app-input
        [label]="'labels.add_new' | translate"
        [placeholder]="'' | translate"
        [formControl]="control"
        type="text"
      ></app-input>
      <div class="actions-container">
        <app-button
          [buttonLabel]="'buttons.cancel' | translate"
          [buttonType]="BUTTON_TYPES.OUTLINED" 
          (click)="cancelAddNew()">
        </app-button>
        <app-button
          [buttonLabel]="'buttons.OK' | translate"
          [buttonType]="BUTTON_TYPES.REGULAR" 
          [buttonDisabled]="control.invalid"
          (click)="confirmAddNew()">
        </app-button>
      </div>
    </div>
  }
  
</div>
